"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUrl = void 0;
/**
 * Creates a URL based on an api url, array of segments and an optional queryParams
 *
 * Whitespace, leading and trailing slashes in the segments are removed
 *
 * @param apiUrl  The root url
 * @param segments  Array of segments to concatenate
 * @param queryParams Optional query parameters
 */
const createUrl = (apiUrl, segments, queryParams) => {
    const url = new URL([apiUrl, ...segments].map(sanitize).join("/"));
    if (queryParams) {
        Object.keys(queryParams).forEach((key) => {
            if (queryParams[key] === undefined)
                return;
            if (Array.isArray(queryParams[key])) {
                queryParams[key].forEach((val) => {
                    url.searchParams.append(key, String(val));
                });
            }
            else {
                url.searchParams.append(key, String(queryParams[key]));
            }
        });
    }
    return url;
};
exports.createUrl = createUrl;
const withoutTrailingSlash = (url) => url.replace(/(\/)*$/, "");
const withoutLeadingSlash = (url) => url.replace(/^(\/)*/, "");
const sanitize = (input) => {
    return withoutTrailingSlash(withoutLeadingSlash(String(input).trim())).trim();
};
